function roundToXDecimalPlaces(numberToRound: number | null, numberOfDecimalPlaces: number): number | null {
    if (numberToRound == null) {
        return null;
    } else {
        return Math.round(numberToRound * 10**numberOfDecimalPlaces) / 10**numberOfDecimalPlaces;
    }
}

export { roundToXDecimalPlaces };
